import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import locatiiRomania from '../date/locatii.json';
import { FaCar, FaHome, FaBriefcase, FaLaptop, FaTshirt, FaWrench, FaCouch, FaBabyCarriage, FaBicycle, FaPaw, FaTools } from 'react-icons/fa';

function EditeazaAnunt() {
  const { id } = useParams();
  const navigate = useNavigate();
  const inputFisierRef = useRef(null);
  
  const [incarca, setIncarca] = useState(true);
  const [pasPrevizualizare, setPasPrevizualizare] = useState(false);
  const [imagini, setImagini] = useState([]);
  
  const [modalCategorii, setModalCategorii] = useState(false);
  const [categorieTemporara, setCategorieTemporara] = useState(null);
  const [modalLocatie, setModalLocatie] = useState(false);
  const [judetTemporar, setJudetTemporar] = useState(null);
  const [cautareJudet, setCautareJudet] = useState('');
  const [cautareLocalitate, setCautareLocalitate] = useState('');

  const [dateFormular, setDateFormular] = useState({
    titlu: '',
    categorie: '',
    subcategorie: '',
    stare: 'Utilizat',
    tipOferta: 'Vinde',
    pret: '',
    moneda: 'LEI',
    negociabil: false,
    descriere: '',
    judet: '',
    localitate: '',
    tipPersoana: 'Persoana fizica',
    numeContact: '',
    emailContact: '',
    telefonContact: ''
  });

  const categoriiComplete = [
    { 
      nume: 'Auto, moto si ambarcatiuni', 
      culoare: 'bg-red-50 text-red-600 group-hover:bg-red-600 group-hover:text-white',
      icon: <FaCar className="w-8 h-8" />,
      subcategorii: ["Autoturisme", "Autoutilitare", "Camioane - Rulote - Remorci", "Motociclete", "Scutere - ATV - UTV", "Ambarcatiuni", "Utilaje agricole si industriale"]
    },
    { 
      nume: 'Imobiliare', 
      culoare: 'bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white',
      icon: <FaHome className="w-8 h-8" />,
      subcategorii: ["Apartamente - Garsoniere de vanzare", "Apartamente - Garsoniere de inchiriat", "Case de vanzare", "Case de inchiriat", "Terenuri", "Spatii comerciale", "Birouri - Spatii industriale", "Cazare - Turism"]
    },
    { 
      nume: 'Locuri de munca', 
      culoare: 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white',
      icon: <FaBriefcase className="w-8 h-8" />,
      subcategorii: ["IT - Telecomunicatii", "Inginerie - Arhitectura", "Vanzari", "Administrativ - Secretariat", "Finante - Contabilitate", "Transport - Logistica", "Constructii - Meseriasi", "Horeca", "Personal medical"]
    },
    { 
      nume: 'Electronice si electrocasnice', 
      culoare: 'bg-purple-50 text-purple-600 group-hover:bg-purple-600 group-hover:text-white',
      icon: <FaLaptop className="w-8 h-8" />,
      subcategorii: ["Telefoane", "Electrocasnice", "Tablete - eReadere", "TV", "Videoproiectoare & Accesorii", "Retelistica & Servere", "Piese telefoane & tablete", "Laptop-Calculator-Gaming", "Ingrijire Personala", "Periferice & Accesorii Laptop-PC-Gaming", "Imprimante, scannere", "Home Cinema & Audio", "Gadgets, Wearables & Camere foto-video", "Drone & accesorii", "Componente Laptop-PC", "Casti Audio", "Casa inteligenta - Smarthome", "Audio Hi Fi & Profesionale", "Aparate medicale & Wellness", "Accesorii telefoane & tablete"]
    },
    { 
      nume: 'Moda si frumusete', 
      culoare: 'bg-pink-50 text-pink-600 group-hover:bg-pink-600 group-hover:text-white',
      icon: <FaTshirt className="w-8 h-8" />,
      subcategorii: ["Incaltaminte barbati", "Haine barbati", "Incaltaminte dama", "Haine dama", "Bijuterii - Accesorii", "Cosmetice - Parfumuri", "Rochii de mireasa"]
    },
    { 
      nume: 'Piese auto', 
      culoare: 'bg-slate-50 text-slate-600 group-hover:bg-slate-600 group-hover:text-white',
      icon: <FaWrench className="w-8 h-8" />,
      subcategorii: ["Piese auto", "Roti - Jante - Anvelope", "Consumabile - Accesorii", "Sisteme Audio - Navigatie", "Echipamente si accesorii moto"]
    },
    { 
      nume: 'Casa si gradina', 
      culoare: 'bg-amber-50 text-amber-600 group-hover:bg-amber-600 group-hover:text-white',
      icon: <FaCouch className="w-8 h-8" />,
      subcategorii: ["Mobila - Decoratiuni", "Materiale constructii si amenajari", "Unelte - Scule - Feronerie", "Termice - Electrice - Sanitare", "Gradina", "Articole menaj"]
    },
    { 
      nume: 'Mama si copilul', 
      culoare: 'bg-teal-50 text-teal-600 group-hover:bg-teal-600 group-hover:text-white',
      icon: <FaBabyCarriage className="w-8 h-8" />,
      subcategorii: ["Haine - Incaltaminte copii", "Carucioare - Landouri", "Camera copilului", "Jucarii", "Alimentatie - Ingrijire", "Articole scolare"]
    },
    { 
      nume: 'Sport, timp liber, arta', 
      culoare: 'bg-cyan-50 text-cyan-600 group-hover:bg-cyan-600 group-hover:text-white',
      icon: <FaBicycle className="w-8 h-8" />,
      subcategorii: ["Biciclete - Fitness - Suplimente", "Echipamente sportive", "Turism - Echipamente", "Arta - Obiecte de colectie", "Instrumente muzicale", "Carti - Muzica - Filme"]
    },
    { 
      nume: 'Animale de companie', 
      culoare: 'bg-orange-50 text-orange-600 group-hover:bg-orange-600 group-hover:text-white',
      icon: <FaPaw className="w-8 h-8" />,
      subcategorii: ["Caini", "Pisici", "Animale de ferma", "Pasari", "Pesti", "Alte animale", "Accesorii si hrana"]
    },
    { 
      nume: 'Servicii', 
      culoare: 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white',
      icon: <FaTools className="w-8 h-8" />,
      subcategorii: ["Auto - Transport", "Meseriasi - Constructori", "Reparatii IT - Electronice", "Evenimente - Divertisment", "Cursuri - Meditatii", "Servicii de curatenie", "Servicii de infrumusetare"]
    }
  ];

  useEffect(() => {
    const preiaDateAnunt = async () => {
      try {
        const raspuns = await fetch(`https://tranzitio.onrender.com/api/anunturi/${id}`);
        if (raspuns.ok) {
          const date = await raspuns.json();
          setDateFormular({
            titlu: date.titlu || '',
            categorie: typeof date.categorie === 'object' ? date.categorie.nume : (date.categorie || ''),
            subcategorie: typeof date.subcategorie === 'object' ? date.subcategorie.nume : (date.subcategorie || ''),
            stare: date.stare || 'Utilizat',
            tipOferta: date.tipOferta || 'Vinde',
            pret: date.pret || '',
            moneda: date.moneda || 'LEI',
            negociabil: date.negociabil || false,
            descriere: date.descriere || '',
            judet: date.judet || '',
            localitate: date.localitate || date.locatie || '',
            tipPersoana: date.tipPersoana || 'Persoana fizica',
            numeContact: date.numeContact || '',
            emailContact: date.emailContact || '',
            telefonContact: date.telefonContact || ''
          });
          
          let poze = [];
          if (Array.isArray(date.imagini) && date.imagini.length > 0) {
            poze = date.imagini.filter(img => typeof img === 'string');
          } else if (typeof date.imagine === 'string' && date.imagine.length > 0) {
            poze = [date.imagine];
          }
          setImagini(poze);
          
        } else {
          toast.error('Anuntul nu a putut fi gasit');
          navigate('/anunturile-mele');
        }
      } catch (eroare) {
        toast.error('Eroare de conexiune la incarcarea anuntului');
      } finally {
        setIncarca(false);
      }
    };

    preiaDateAnunt();
  }, [id, navigate]);

  const actualizareDate = (e) => {
    const { name, value, type, checked } = e.target;
    setDateFormular(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const selecteazaSubcategorie = (numeSubcategorie) => {
    setDateFormular(prev => ({
      ...prev,
      categorie: categorieTemporara.nume,
      subcategorie: numeSubcategorie
    }));
    setModalCategorii(false);
    setCategorieTemporara(null);
  };

  const selecteazaLocalitate = (loc) => {
    setDateFormular(prev => ({
      ...prev,
      judet: judetTemporar,
      localitate: loc
    }));
    setModalLocatie(false);
    setJudetTemporar(null);
    setCautareJudet('');
    setCautareLocalitate('');
  };

  const proceseazaImagini = (e) => {
    const fisiere = Array.from(e.target.files);
    if (imagini.length + fisiere.length > 8) {
      return toast.error('Poti adauga maxim 8 imagini');
    }

    fisiere.forEach(fisier => {
      const reader = new FileReader();
      reader.readAsDataURL(fisier);
      reader.onloadend = () => {
        setImagini(prev => [...prev, reader.result]);
      };
    });
  };

  const stergeImagine = (index) => {
    setImagini(imagini.filter((_, i) => i !== index));
  };

  const validareFormular = () => {
    if (dateFormular.titlu.length < 16) return toast.error('Titlul trebuie sa aiba minim 16 caractere');
    if (!dateFormular.categorie || !dateFormular.subcategorie) return toast.error('Selecteaza o categorie');
    if (imagini.length === 0) return toast.error('Adauga cel putin o imagine');
    if (!dateFormular.pret) return toast.error('Introdu un pret valid');
    if (dateFormular.descriere.length < 40) return toast.error('Descrierea trebuie sa aiba minim 40 caractere');
    if (!dateFormular.judet || !dateFormular.localitate) return toast.error('Selecteaza locatia');
    if (!dateFormular.telefonContact) return toast.error('Introdu un numar de telefon');
    return true;
  };

  const salveazaModificarile = async () => {
    try {
      const token = localStorage.getItem('token');
      const dateDeTrimis = { ...dateFormular, imagini, imagine: imagini[0] };

      const raspuns = await fetch(`https://tranzitio.onrender.com/api/anunturi/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        },
        body: JSON.stringify(dateDeTrimis)
      });

      if (raspuns.ok) {
        toast.success('Anunt modificat cu succes');
        navigate('/anunturile-mele');
      } else {
        const dateEroare = await raspuns.json();
        toast.error(dateEroare.mesaj || 'A aparut o eroare la salvare');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune cu serverul');
    }
  };

  const judeteFiltrate = Object.keys(locatiiRomania).filter(jud => 
    jud.toLowerCase().includes(cautareJudet.toLowerCase())
  );

  const localitatiFiltrate = judetTemporar ? locatiiRomania[judetTemporar].filter(loc => 
    loc.toLowerCase().includes(cautareLocalitate.toLowerCase())
  ) : [];

  if (incarca) {
    return (
      <div className="min-h-screen bg-[#f3f4f6] flex justify-center items-center">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (pasPrevizualizare) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8 min-h-screen">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-black text-gray-800">Previzualizare modificari</h1>
          <button onClick={() => setPasPrevizualizare(false)} className="text-blue-600 font-bold hover:underline">Inapoi la editare</button>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-6">
          <div className="flex justify-between items-start mb-6">
            <div>
              <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3 inline-block">
                {dateFormular.subcategorie}
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-2">{dateFormular.titlu}</h2>
              <p className="text-gray-500 font-medium flex items-center gap-2">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /></svg>
                {dateFormular.localitate}, {dateFormular.judet}
              </p>
            </div>
            <div className="text-right">
              <p className="text-4xl font-black text-blue-700">{dateFormular.pret} {dateFormular.moneda}</p>
              {dateFormular.negociabil && <p className="text-sm text-gray-500 font-bold mt-1">Negociabil</p>}
            </div>
          </div>

          {imagini.length > 0 && (
            <div className="w-full h-96 bg-gray-100 rounded-xl mb-8 overflow-hidden">
              <img src={imagini[0]} alt="Principal" className="w-full h-full object-contain" />
            </div>
          )}

          <div className="grid grid-cols-2 gap-4 mb-8 bg-gray-50 p-6 rounded-xl">
            <div><span className="text-gray-500">Stare:</span> <span className="font-bold text-gray-900">{dateFormular.stare}</span></div>
            <div><span className="text-gray-500">Oferta:</span> <span className="font-bold text-gray-900">{dateFormular.tipOferta}</span></div>
            <div><span className="text-gray-500">Vanzator:</span> <span className="font-bold text-gray-900">{dateFormular.tipPersoana}</span></div>
            <div><span className="text-gray-500">Contact:</span> <span className="font-bold text-gray-900">{dateFormular.numeContact}</span></div>
          </div>

          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Descriere</h3>
            <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">{dateFormular.descriere}</p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button onClick={() => setPasPrevizualizare(false)} className="px-8 py-3 rounded-xl font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 transition">Modifica</button>
          <button onClick={salveazaModificarile} className="px-10 py-3 rounded-xl font-bold text-white bg-blue-600 hover:bg-blue-700 transition shadow-md">Salveaza modificarile</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6] py-10 relative">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-black text-gray-900 mb-8">Editeaza anuntul</h1>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Informatii de baza</h2>
          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Titlul anuntului *</label>
            <input type="text" name="titlu" value={dateFormular.titlu} onChange={actualizareDate} maxLength={70} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition" />
            <div className="flex justify-between text-xs text-gray-500 mt-1"><span>Introdu cel putin 16 caractere</span><span>{dateFormular.titlu.length}/70</span></div>
          </div>
          
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Categoria *</label>
            {!dateFormular.categorie ? (
              <button 
                onClick={() => setModalCategorii(true)}
                className="w-full md:w-auto px-6 py-4 bg-gray-50 border border-gray-300 rounded-lg text-gray-700 font-bold hover:bg-gray-100 transition flex items-center justify-between gap-4"
              >
                Selecteaza categoria
                <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
              </button>
            ) : (
              <div className="flex items-center justify-between p-4 bg-blue-50 border border-blue-100 rounded-lg">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${categoriiComplete.find(c => c.nume === dateFormular.categorie)?.culoare || 'bg-gray-200 text-gray-500'}`}>
                    {categoriiComplete.find(c => c.nume === dateFormular.categorie)?.icon || <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{dateFormular.categorie}</p>
                    <p className="text-sm text-gray-600 font-medium">{dateFormular.subcategorie}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setModalCategorii(true)}
                  className="text-sm font-bold text-blue-600 hover:text-blue-800 underline"
                >
                  Modifica
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Imagini</h2>
          <p className="text-gray-500 text-sm mb-6">Prima imagine va fi imaginea principala. Poti adauga maxim 8 imagini.</p>
          
          <input type="file" multiple accept="image/*" className="hidden" ref={inputFisierRef} onChange={proceseazaImagini} />
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {imagini.length < 8 && (
              <div onClick={() => inputFisierRef.current.click()} className="aspect-square bg-blue-50 border-2 border-dashed border-blue-200 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:bg-blue-100 transition">
                <span className="font-bold text-blue-600 text-sm">+ Adauga</span>
              </div>
            )}
            
            {imagini.map((imgUrl, idx) => (
              <div key={idx} className="aspect-square relative rounded-xl overflow-hidden border border-gray-200 group">
                <img src={imgUrl} alt={`Poza ${idx}`} className="w-full h-full object-cover" />
                <button onClick={() => stergeImagine(idx)} className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity shadow-md hover:bg-red-600">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-6">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Despre produs</h2>
          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Stare *</label>
            <div className="flex gap-2">
              <button onClick={() => setDateFormular(prev => ({...prev, stare: 'Utilizat'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.stare === 'Utilizat' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Utilizat</button>
              <button onClick={() => setDateFormular(prev => ({...prev, stare: 'Nou'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.stare === 'Nou' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Nou</button>
            </div>
          </div>
          <div className="mb-6">
            <div className="flex gap-2">
              <button onClick={() => setDateFormular(prev => ({...prev, tipOferta: 'Vinde'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.tipOferta === 'Vinde' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Vinde</button>
              <button onClick={() => setDateFormular(prev => ({...prev, tipOferta: 'Schimb'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.tipOferta === 'Schimb' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Schimb</button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Pret *</label>
              <div className="flex gap-2">
                <input type="number" name="pret" value={dateFormular.pret} onChange={actualizareDate} className="flex-1 px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition" />
                <select name="moneda" value={dateFormular.moneda} onChange={actualizareDate} className="w-24 px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition font-bold"><option value="LEI">lei</option><option value="EUR">eur</option></select>
              </div>
            </div>
            <div className="flex items-center gap-3 md:pt-8">
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" name="negociabil" checked={dateFormular.negociabil} onChange={actualizareDate} className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
                <span className="ml-3 text-sm font-bold text-gray-700">Negociabil</span>
              </label>
            </div>
          </div>
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Descriere *</label>
            <textarea name="descriere" value={dateFormular.descriere} onChange={actualizareDate} rows={8} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition resize-none"></textarea>
            <div className="flex justify-between text-xs text-gray-500 mt-1"><span>Introdu cel putin 40 caractere</span><span>{dateFormular.descriere.length}/9000</span></div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Despre tine</h2>
          
          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Unde se afla produsul? *</label>
            {!dateFormular.judet ? (
              <button 
                onClick={() => setModalLocatie(true)}
                className="w-full md:w-auto px-6 py-4 bg-gray-50 border border-gray-300 rounded-lg text-gray-700 font-bold hover:bg-gray-100 transition flex items-center justify-between gap-4"
              >
                Selecteaza locatia
                <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /></svg>
              </button>
            ) : (
              <div className="flex items-center justify-between p-4 bg-emerald-50 border border-emerald-100 rounded-lg">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /></svg>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{dateFormular.localitate}</p>
                    <p className="text-sm text-gray-600 font-medium">Judetul {dateFormular.judet}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setModalLocatie(true)}
                  className="text-sm font-bold text-blue-600 hover:text-blue-800 underline"
                >
                  Modifica
                </button>
              </div>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-sm font-bold text-gray-700 mb-2">Persoana fizica sau firma *</label>
            <div className="flex gap-2">
              <button onClick={() => setDateFormular(prev => ({...prev, tipPersoana: 'Persoana fizica'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.tipPersoana === 'Persoana fizica' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Persoana fizica</button>
              <button onClick={() => setDateFormular(prev => ({...prev, tipPersoana: 'Firma'}))} className={`flex-1 py-3 rounded-lg font-bold transition ${dateFormular.tipPersoana === 'Firma' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}>Firma</button>
            </div>
          </div>
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Persoana de contact *</label>
              <input type="text" name="numeContact" value={dateFormular.numeContact} onChange={actualizareDate} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition" />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Adresa de email</label>
              <input type="email" value={dateFormular.emailContact} disabled className="w-full px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg text-gray-500 font-medium cursor-not-allowed" />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Numarul de telefon *</label>
              <input type="tel" name="telefonContact" value={dateFormular.telefonContact} onChange={actualizareDate} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition" />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4 border-t border-gray-200 pt-8 pb-12">
          <button onClick={() => navigate('/anunturile-mele')} className="px-8 py-4 rounded-xl font-bold text-gray-700 bg-gray-100 border border-gray-300 hover:bg-gray-200 transition shadow-sm">Anuleaza</button>
          <button onClick={() => validareFormular() && setPasPrevizualizare(true) && window.scrollTo(0,0)} className="px-8 py-4 rounded-xl font-bold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 transition shadow-sm">Previzualizeaza</button>
          <button onClick={() => validareFormular() && salveazaModificarile()} className="px-10 py-4 rounded-xl font-bold text-white bg-blue-600 hover:bg-blue-700 transition shadow-md">Salveaza modificarile</button>
        </div>
      </div>

      {modalCategorii && (
        <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">
                {categorieTemporara ? 'Alege subcategoria' : 'Alege categoria'}
              </h3>
              <button onClick={() => { setModalCategorii(false); setCategorieTemporara(null); }} className="text-gray-400 hover:text-gray-600 transition p-2 rounded-full hover:bg-gray-100">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto">
              {!categorieTemporara ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {categoriiComplete.map(cat => (
                    <button
                      key={cat.nume}
                      onClick={() => setCategorieTemporara(cat)}
                      className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 hover:border-blue-500 hover:shadow-md transition text-left group"
                    >
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center transition ${cat.culoare} group-hover:scale-110`}>
                        {cat.icon}
                      </div>
                      <span className="font-bold text-gray-800 text-sm">{cat.nume}</span>
                    </button>
                  ))}
                </div>
              ) : (
                <div>
                  <button 
                    onClick={() => setCategorieTemporara(null)}
                    className="flex items-center gap-2 text-sm font-bold text-gray-500 hover:text-gray-800 transition mb-6"
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" /></svg>
                    Inapoi la categorii
                  </button>
                  <div className="flex flex-col gap-2">
                    {categorieTemporara.subcategorii.map(sub => (
                      <button
                        key={sub}
                        onClick={() => selecteazaSubcategorie(sub)}
                        className="text-left px-6 py-4 rounded-xl border border-gray-100 hover:bg-blue-50 hover:text-blue-700 hover:border-blue-200 font-medium text-gray-700 transition"
                      >
                        {sub}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {modalLocatie && (
        <div className="fixed inset-0 z-[110] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">
                {judetTemporar ? `Localitati in ${judetTemporar}` : 'Alege judetul'}
              </h3>
              <button onClick={() => { setModalLocatie(false); setJudetTemporar(null); setCautareJudet(''); setCautareLocalitate(''); }} className="text-gray-400 hover:text-gray-600 transition p-2 rounded-full hover:bg-gray-100">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto">
              {!judetTemporar ? (
                <div className="flex flex-col gap-4">
                  <div className="relative">
                    <svg className="w-5 h-5 absolute left-3 top-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                    <input 
                      type="text" 
                      placeholder="Cauta judetul tau..." 
                      value={cautareJudet}
                      onChange={(e) => setCautareJudet(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:bg-white focus:border-blue-500 transition font-medium"
                    />
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                    {judeteFiltrate.map(jud => (
                      <button
                        key={jud}
                        onClick={() => { setJudetTemporar(jud); setCautareJudet(''); }}
                        className="p-4 rounded-xl border border-gray-100 hover:border-blue-500 hover:bg-blue-50 text-center font-bold text-gray-700 transition"
                      >
                        {jud}
                      </button>
                    ))}
                    {judeteFiltrate.length === 0 && <p className="col-span-full text-center py-4 text-gray-500 font-medium">Nu am gasit niciun judet.</p>}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  <button 
                    onClick={() => { setJudetTemporar(null); setCautareLocalitate(''); }}
                    className="flex items-center gap-2 text-sm font-bold text-gray-500 hover:text-gray-800 transition w-fit"
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" /></svg>
                    Inapoi la judete
                  </button>
                  <div className="relative">
                    <svg className="w-5 h-5 absolute left-3 top-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                    <input 
                      type="text" 
                      placeholder="Cauta localitatea ta..." 
                      value={cautareLocalitate}
                      onChange={(e) => setCautareLocalitate(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:bg-white focus:border-blue-500 transition font-medium"
                    />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {localitatiFiltrate.map(loc => (
                      <button
                        key={loc}
                        onClick={() => selecteazaLocalitate(loc)}
                        className="text-left px-6 py-4 rounded-xl border border-gray-100 hover:bg-emerald-50 hover:text-emerald-700 hover:border-emerald-200 font-medium text-gray-700 transition"
                      >
                        {loc}
                      </button>
                    ))}
                    {localitatiFiltrate.length === 0 && <p className="col-span-full text-center py-4 text-gray-500 font-medium">Nu am gasit nicio localitate.</p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default EditeazaAnunt;